import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { publishLast, refCount } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { LinkedinIconComponent } from './social-icons/linkedin/linkedin-icon.component';
import { TiktokIconComponent } from './social-icons/tiktok/tiktok-icon.component';
import { InstagramIconComponent } from '@app/shared/components/loyalty-club-footer/social-icons/instagram/instagram-icon.component';
import { FacebookIconComponent } from './social-icons/facebook/facebook-icon.component';
import { IconComponent } from '@app/shared/components/icon/icon.component';

@Component({
  selector: 'app-loyalty-club-footer',
  templateUrl: './loyalty-club-footer.component.html',
  imports: [
    TranslateModule,
    CommonModule,
    LinkedinIconComponent,
    TiktokIconComponent,
    InstagramIconComponent,
    FacebookIconComponent,
    IconComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoyaltyClubFooterComponent {
  protected currentYear = new Date().getFullYear();
  protected settings$ = this.settingsService.getSettingsOnce().pipe(publishLast(), refCount());

  constructor(private settingsService: SettingsService) {
  }
}
